import { CREATE_LEAD_FAILURE, CREATE_LEAD_REQUEST, CREATE_LEAD_SUCCESS, DELETE_LEAD_FAILURE, DELETE_LEAD_REQUEST, DELETE_LEAD_SUCCESS, EDIT_LEAD_ALL_FAILURE, EDIT_LEAD_ALL_SUCCESS, RESET_SUCCESS_STATE } from "./actionsType";

const initialState = {
    leads: [],
    loading: false,
    error: null,
    success: false,
};

const LeadReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_LEAD_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                success: false,
            };
        case CREATE_LEAD_SUCCESS:
            return {
                ...state,
                loading: false,
                leads: action.payload,
                error: null,
                success: true,
            };
        case CREATE_LEAD_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case DELETE_LEAD_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case DELETE_LEAD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                error: null,
            };
        case DELETE_LEAD_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case EDIT_LEAD_ALL_SUCCESS: {
            const updatedTeam = action.payload;
            return {
                ...state,
                loading: false,
                team: [...state.leads, updatedTeam],
                success: true,
                error: null,
            };
        }
        case EDIT_LEAD_ALL_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: false,
            };
        case RESET_SUCCESS_STATE:
            return {
                ...state,
                success: false,
            };
        default:
            return state;
    }
};

export default LeadReducer